import React from 'react';
import PropTypes from 'prop-types';
import { DROPZONE_ACCEPTED_FILES_ARRAY } from "../../helpers/variables";
import { Link, FormGroup, HorizontalRule } from 'arag-ui-lib';
import { FORM_GROUP_VARIANTS, SECONDARY_VARIANT_STYLE } from "../../helpers/formGroupVariants";
import CONTENT_STRINGS from '../../helpers/contentStrings';

const OverviewTabFormFile = (props) => {

    const { 
        attachment, 
        attachmentIndex,
        onAttachmentDrop,
        changeOverviewAttachment,
        removeOverviewAttachment,
    } = props;

    return (
        <div>
            {attachmentIndex > 0 && (
                <>
                    <div className='col-sm-3'></div>
                    <Link 
                        variant={'tertiary'}
                        label={'Remove'}
                        arrowDirection={'left'}
                        onClick={() => removeOverviewAttachment({ attachmentIndex: attachmentIndex })}
                        linkTestId={`overview-remove-attachment-${attachmentIndex}`}
                    />
                </>
            )}
            <FormGroup
                labelSize={"col-sm-3"}
                inputSize={"col-sm-6"}
                label={CONTENT_STRINGS.UPLOAD_FILE}
                variant={FORM_GROUP_VARIANTS.FILE}
                inputProps={{
                    name: 'attachment',
                    key: 'attachment',
                    label: attachment.attachment.name ? attachment.attachment.name : CONTENT_STRINGS.DRAG_AND_DROP,
                    accepts: DROPZONE_ACCEPTED_FILES_ARRAY,
                    allowMultiple: false,
                    onDrop: (files) => onAttachmentDrop(files, attachmentIndex)
                }}
                formGroupTestId={`overview-upload-file-${attachmentIndex}`}
                requiredStyle={SECONDARY_VARIANT_STYLE}
            />
            <FormGroup
                labelSize={"col-sm-3"}
                inputSize={"col-sm-6"}
                label={"Add Tags (separate with commas)"}
                variant={FORM_GROUP_VARIANTS.TEXT}
                inputProps={{
                    name: 'tags',
                    key: 'tags',
                    onChange: (e) => changeOverviewAttachment({
                        attachmentIndex: attachmentIndex,
                        value: e.target.value
                    })
                }}
                formGroupTestId={`overview-add-tags-${attachmentIndex}`}
                requiredStyle={SECONDARY_VARIANT_STYLE}
            />
            <div className='row'><div className='col-sm-9'><HorizontalRule variant='pale'/></div></div>
        </div>
    )
};

OverviewTabFormFile.propTypes = {
    attachment: PropTypes.shape({
        attachment: PropTypes.shape({
            name: PropTypes.string
        }),
        comments: PropTypes.string
    }).isRequired,
    attachmentIndex: PropTypes.number.isRequired,
    onAttachmentDrop: PropTypes.func.isRequired,
    changeOverviewAttachment: PropTypes.func.isRequired,
    removeOverviewAttachment: PropTypes.func.isRequired
};

export default OverviewTabFormFile;